import PropTypes from 'prop-types'

/**
 * @typedef {Object} EnergyConsumptionForSpeed
 *
 * Energy consumption measured over a distance of 100km with constant speed
 *
 * @property {number} energyInkWh - Energy consumption value in kWh unit
 * @property {number} speed - Vehicle speed in kmh unit
 */
export const energyConsumptionForSpeedPropType = PropTypes.shape({
    energyInkWh: PropTypes.number.isRequired,
    speed: PropTypes.number.isRequired
})
